<template>
  <div class="study-rank">
    <chooseState :chooses="chooses"></chooseState>
    <studyTable
      :tableData="tableDataTemp"
      :columns="columns"
      :num="num"
      :pages="pages"
      :shows="true"
      @nextTable="FnextTable"
    ></studyTable>
    <div class="motai" v-if="motai">
      <div class="msg">
        <img src="@/assets/dataQuery/dp-ld-dl.png" alt @click="hideMotai" />
        <div class="title">
          <p>{{nextTitle}}</p>
          <p>三会一课开展次数详情</p>
        </div>
        <studyTable
          :tableData="nextTableDataTemp"
          :columns="nextColumns"
          :num="nextNum"
          :pages="nextPages"
        ></studyTable>
      </div>
    </div>
  </div>
</template>
<script>
import chooseState from "./module/_studyChoose";
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      tableData: [],
      columns: [
        { name: "开展对象", prop: "areaname" },
        { name: "三会一课开展次数", prop: "count" }
      ],
      tableDataTemp: [],
      pages: 1,
      num: 1,
      chooses: [{ name: "按乡/镇查询" }, { name: "按村/社区查询" }],
      nextTitle: "",
      nextTableDataTemp: [],
      nextPages: 1,
      nextNum: 1,
      nextTableData: [],
      nextColumns: [
        { name: "村", prop: "Town" },
        { name: "开展次数", prop: "TownCount" },
        { name: "开展时间", prop: "Time" }
      ],
      motai: false,
      choosed: 1
    };
  },
  components: {
    chooseState,
    studyTable
  },
  methods: {
    hideMotai() {
      this.motai = false;
    },
    getMsg() {
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/Meet", {
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token"),
          c2town: sessionStorage.getItem("town"),
          c1status: this.choosed
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.tableData = e.data.msg;
              this.num = this.tableData.length;
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item);
                }
              });
              this.pages = Number.parseInt(
                this.tableData.length % 10 > 0
                  ? this.tableData.length / 10 + 1
                  : this.tableData.length / 10
              );
              console.log(this.pages);
              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    FnextTable(value, name) {
      console.log(this.choosed);
      this.nextTitle = name;
      if (value) {
        this.motai = value;
        let url = "";
        if (this.choosed == 1) {
          url = `/api/Statistics/MeetDetails?tship=${name}&ship=${name}`;
        } else
          [
            (url = `/api/Statistics/MeetDetails?tship=${sessionStorage.getItem(
              "town"
            )}&ship=${name}`)
          ];
        this.nextTableDataTemp = [];

        this.axios.get(url).then(e => {
          console.log(e.data);
          this.nextTableData = e.data.msg;
          this.nextNum = this.nextTableData.length;
          this.nextTableData.some((item, index) => {
            if (index == 10) return true;
            else {
              this.nextTableDataTemp.push(item);
            }
          });
          this.nextPages = Number.parseInt(
            this.nextTableData.length % 10 > 0
              ? this.nextTableData.length / 10 + 1
              : this.nextTableData.length / 10
          );
        });
      }
    }
  },
  mounted() {
    this.getMsg();
  }
};
</script>
<style lang='scss' scoped>
.study-rank {
  .motai {
    .msg {
      img {
        position: absolute;
        right: 0;
        top: 0;
        width: 0.75rem;
        height: 0.78rem;
      }
      .title {
        p {
          &:nth-child(1) {
            padding-top: 0.3rem;
          }
          &:nth-child(2) {
            color: #666666;
          }
        }
        text-align: center;
        line-height: 2;
      }
      width: 90%;
      margin: 10vh auto;
      background: #fff;
      border-radius: 0.16rem;
      height: 80vh;
      position: relative;
      overflow-y: scroll;
    }
    width: 100%;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.2);
    height: 100vh;
    top: 0;
    z-index: 8;
  }
  padding-top: 1.1rem;
  font-size: 0.3rem;
}
</style>